module.exports = __webpack_public_path__ + "img/galery-dcu30-3-zoom.bbd4589b.png";